export const namespaceReducer = (namespace, reducer) => (state, ...rest) =>
  state.mergeIn([namespace], reducer(state.get(namespace), ...rest));
